import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { lighten, useTheme, Dialog, DialogContent } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { TnADayDataDTO } from "src/models/tna/tna-data/tna-day-data-dto";
import { TnAOverviewDTO } from "../../../../models/tna-overviews";
import AddEditButton from "../../../../reusable-components/AddEditButton/AddEditButton";
import SimplePopover from "../../../../reusable-components/SimplePopover/SimplePopover";
import DialogTitle from "../../../DialogTitle/DialogTitle";
import LoadingOverlay from "../../../LoadingOverlay/LoadingOverlay";
import SendMassAnomaliesNotificationsWrapper from "../../SendMassAnomaliesNotificationsWrapper/SendMassAnomaliesNotificationsWrapper";

interface Props {
  item: TnAOverviewDTO;
  handleNotifyParent: () => void;
}

interface State {
  loading: boolean;
  shouldClosePopover: boolean;
  isOpen: boolean;
}

const TimesheetAnomaliesActions = ({ item, handleNotifyParent }: Props) => {
  const { t } = useTranslation();
  const tRP = "components.team_presence_and_leaves_dashboard";
  const theme = useTheme();

  const [state, setState] = useState<State>({
    loading: false,
    shouldClosePopover: false,
    isOpen: false,
  });

  const handleNotify = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      shouldClosePopover: true,
      isOpen: false,
    }));
    handleNotifyParent();
  }, [handleNotifyParent]);

  const handleClose = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  }, []);

  return (
    <>
      <SimplePopover
        buttonType="icon"
        buttonContent={<FontAwesomeIcon icon={faEllipsisH} />}
        customButtonStyle={{
          color: lighten(theme.palette.primary.main, 0.5),
          padding: "8px",
        }}
        shouldClose={state.shouldClosePopover}
      >
        <AddEditButton
          title={t(`${tRP}.notify_employee_about_anomaly`)}
          effect="edit"
          onClick={() => {
            setState((prevState) => ({ ...prevState, isOpen: true, shouldClosePopover: true }));
          }}
          buttonText={t(`${tRP}.notify_employee_about_anomaly`)}
          customStyle={{
            minWidth: "200px",
            width: "fit-content",
            justifyContent: "flex-start",
            textTransform: "none",
            color: theme.palette.primary.main,
            fontSize: "14px",
          }}
          disabled={state.loading}
        />
      </SimplePopover>

      <Dialog
        open={state.isOpen}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              maxWidth: "90% !important",
            },
          },
          "& .MuiDialogActions-root": {
            padding: "0 !important",
          },
        }}
      >
        {state.isOpen && (
          <>
            <DialogTitle
              title={t(`${tRP}.notify_employee_about_anomaly`)}
              handleClose={handleClose}
            />
            <LoadingOverlay loading={state.loading}>
              <DialogContent sx={{ paddingTop: "0 !important" }}>
                <SendMassAnomaliesNotificationsWrapper
                  item={item as unknown as TnADayDataDTO}
                  handleNotifyParent={handleNotify}
                  employee={item.employee}
                  handleParentClose={handleClose}
                />
              </DialogContent>
            </LoadingOverlay>
          </>
        )}
      </Dialog>
    </>
  );
};

export default TimesheetAnomaliesActions;
